module.exports = __webpack_public_path__ + "static/media/invert.8d0d2d6e.svg";